import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'shorten',
})
export class ShortenPipe implements PipeTransform {
  transform(value: any) {
    // definimos um tamanho máximo de 144 caracteres no total, para os textos.
    // essa função é usada para mostrar o texto curto
    const str = value.replace(/\<.*?\>(.*?)\<\/.*?\>/gi, '$1');
    if (str.length > 144) {
      return value.slice(0, 144) + '...';
    }
    return value;
  }
}
